import { IVec3, Vec3 } from "@base/math/Vec3";
import { ImmHelper } from "@base/util/Immutable";
import { IFenceData } from "@biz/items/fence/FenceDefinitions";
import { getItemLayerReducers } from "@biz/reducers/ItemLayerReducer";

export const FenceReducer = {
  ...getItemLayerReducers<IFenceData>(),
  setCorner(old: IFenceData, index: number, p: IVec3): IFenceData {
    return {
      ...old,
      corners: ImmHelper.setArrayItem(old.corners, index, p)
    }
  },
  setCorners(old: IFenceData, points: IVec3[]): IFenceData {
    return ImmHelper.setProperty(old, "corners", points);
  },
  addCorner(old: IFenceData, index: number, p?: IVec3): IFenceData {
    if (!p) {
      if (index < old.corners.length - 1)
        p = Vec3.mid(old.corners[index], old.corners[index + 1]);
      else
        p = Vec3.addScaled(old.corners[index], Vec3.to(old.corners[index - 1], old.corners[index]), 1.0);
    }
    return {
      ...old,
      corners: ImmHelper.insertArrayItem(old.corners, index + 1, p)
    }
  },
  removeCorner(old: IFenceData, index: number, _p?: IVec3): IFenceData {
    return {
      ...old,
      corners: ImmHelper.removeArrayItem(old.corners, index)
    }
  },
  setHeight(old: IFenceData, height: number): IFenceData {
    return ImmHelper.setProperty(old, "height", height);
  },
  setNiveau(old: IFenceData, niveau: number): IFenceData {
    return ImmHelper.setProperty(old, "corners", old.corners.map((p) => Vec3.withY(p, niveau)))
  }
}